import { Outlet } from 'react-router-dom';
import { AuthPageShell, SideRailShell } from '@/components';
import { useIsOperator } from '@/auth.ts';
import { ROUTES } from '@/routes.ts';
import { BarChartIcon, ListBulletIcon } from '@/components/icons.tsx';

export function OperatorDashboard() {
  const isOperator = useIsOperator();

  if (!isOperator) {
    return (
      <AuthPageShell>
        <p className="text-muted status-message">U heeft geen toegang tot dit scherm. Enkel beheerders hebben toegang.</p>
      </AuthPageShell>
    );
  }

  return (
    <SideRailShell
      label="Beheerder navigatie"
      items={[
        { to: ROUTES.operatorOperations, label: 'Beheer',       icon: <ListBulletIcon size={20} /> },
        { to: ROUTES.operatorAnalytics,  label: 'Statistieken', icon: <BarChartIcon size={20} /> },
      ]}
    >
      <Outlet />
    </SideRailShell>
  );
}
